module.exports = __webpack_public_path__ + "img/welcomeImage.63fa2f3a.png";